module.exports = __webpack_public_path__ + "img/paid.b296799c.svg";